import {
  callApiSearchHoSoCongViec,
  callApiTaoHoSoCongViec,
  callApiLayChiTietHoSoCongViec,
  callApiSuaHoSoCongViec,
  callApiThemYKienXuLy,
  callApiXoaHoSoCongViec,
  callApiExportHoSoCongViec,
  callApiPhanXuLy,
  callApiTraLai,
  callApiLayDoiTuongDuocTraLai,
  callApiLayTreeDonVi,
  callApiLayTreePhanXuLy,
  callApiLayLichSuThuHoi,
  callApiLayLichSuTraLai,
  callApiLayLichSuCapNhatTinhHinhThucHien,
  callApiCapNhatTHTH,
  callApiLayLichSuPhanXuLy,
  callApiMoLai,
  callApiLayLuongXuLy,
  callApiGetCountList,
  callApiThuHoiHoSoCongViec,
  callApiGetTreeDaPhanXuLy,
  callApiCapNhatVaiTroTreePXL,
  callApiDuyetHSCV,
  callApiHuyDuyetHSCV,
  callApiXinYKien,
  callApiKetThuc,
  callApiSetDangXuLy,
  callApiSetDaXuLy,
  callApiSuaYKienXuLy,
  callApiXoaYKienXuLy,
  callApiCapNhatVanBan,
  callApiCapNhatFile,
  callApiDanhSachYKienPhanTrang,
} from "@/api/ho-so-cong-viec";
import Vue from "vue";

const searchHoSoCongViec = (context, payload) => {
  context.commit("LAY_DANH_SACH_HO_SO_CONG_VIEC", []);
  return new Promise((resolve, reject) => {
    callApiSearchHoSoCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_HO_SO_CONG_VIEC", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const taoHoSoCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoHoSoCongViec(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaHoSoCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaHoSoCongViec(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaHoSoCongViecVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatVanBan(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaHoSoCongViecFile = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatFile(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietHoSoCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietHoSoCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_CHI_TIET_HO_SO_CONG_VIEC", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themYKienXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemYKienXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaYKienXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaYKienXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaYKienXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaYKienXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaHoSoCongViec = async (context, payload) => {
  try {
    const response = await callApiXoaHoSoCongViec(payload.data.Ids);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess();
      Vue.toasted.clear();
      Vue.toasted.global.showSuccessMessage({
        message: "Xóa hồ sơ công việc thành công",
      });
      await getCountList(context);
    } else {
      Vue.toasted.clear();
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
      payload.onFailed && payload.onFailed(response.data.Messages[0]);
    }
  } catch (error) {
    console.log(error);
  }
};

const exportHoSoCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiExportHoSoCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const phanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiPhanXuLy(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const traLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTraLai(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const ketThuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiKetThuc(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const moLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiMoLai(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDoiTuongDuocTraLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDoiTuongDuocTraLai(payload)
      .then((response) => {
        if (response) {
          if (response.data.IsSuccess) {
            context.commit("SET_DOI_TUONG_DUOC_TRA_LAI", response.data.Data);
          } else {
            context.commit("SET_DOI_TUONG_DUOC_TRA_LAI", []);
            Vue.toasted.clear();
            Vue.toasted.global.showErrorMessage({
              message: response.data.Messages[0] || "Thao tác thất bại!",
            });
          }
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTreeDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    context.commit("SET_TREE_DON_VI", []);
    callApiLayTreeDonVi(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_TREE_DON_VI", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTreePhanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayTreePhanXuLy(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_TREE_PHAN_XU_LY", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layLichSuThuHoi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLichSuThuHoi(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_LICH_SU_THU_HOI", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layLichSuTraLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLichSuTraLai(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_LICH_SU_TRA_LAI", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layLichSuCapNhatTinhHinhThucHien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLichSuCapNhatTinhHinhThucHien(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_LICH_SU_CAP_NHAT_TINH_HINH_THUC_HIEN",
            response.data.Data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const capNhatTHTH = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatTHTH(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layLichSuPhanXuLy = (context, id) => {
  return new Promise((resolve, reject) => {
    callApiLayLichSuPhanXuLy(id)
      .then((response) => {
        if (response) {
          context.commit("SET_LICH_SU_PHAN_XU_LY", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layLuongXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLuongXuLy(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_LUONG_XU_LY", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const thuHoi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThuHoiHoSoCongViec(payload)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCountList = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetCountList(payload)
      .then((response) => {
        if (response && !(payload || {}).preventCommit) {
          context.commit("SET_COUNT_LIST", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getTreeDaPhanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTreeDaPhanXuLy(payload)
      .then((response) => {
        if (response) {
          if (response.data.IsSuccess) {
            context.commit("SET_TREE_DA_PHAN_XU_LY", response.data.Data);
          } else {
            if (!payload.notShowError) {
              context.commit("SET_TREE_DA_PXL_SEARCH_DATA", []);
              Vue.toasted.clear();
              Vue.toasted.global.showErrorMessage({
                message: response.data.Messages[0] || "Thao tác thất bại!",
              });
            }
          }
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_TREE_DA_PXL_SEARCH_DATA", []);
        Vue.toasted.clear();
        Vue.toasted.global.showErrorMessage({
          message: error.response.data.Messages[0] || "Thao tác thất bại!",
        });
        reject(error);
      });
  });
};

const setDangXuLy = async (context, payload) => {
  try {
    const response = await callApiSetDangXuLy(payload.id);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Messages[0]);
    }
  } catch (error) {
    console.log(error);
  }
};

const setDaXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSetDaXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const capNhatVaiTroTreePhanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatVaiTroTreePXL(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const duyetHSCV = (context, id) => {
  return new Promise((resolve, reject) => {
    callApiDuyetHSCV(id)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const huyDuyetHSCV = (context, id) => {
  return new Promise((resolve, reject) => {
    callApiHuyDuyetHSCV(id)
      .then((response) => {
        resolve(response);
        getCountList(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xinYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXinYKien(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getTreeDaPXLSearchData = (context, id) => {
  return new Promise((resolve, reject) => {
    callApiGetTreeDaPhanXuLy(id)
      .then((response) => {
        if (response) {
          if (response.data.IsSuccess) {
            context.commit("SET_TREE_DA_PXL_SEARCH_DATA", response.data.Data);
          } else {
            context.commit("SET_TREE_DA_PXL_SEARCH_DATA", []);
            if (!id.notShowError) {
              Vue.toasted.clear();
              Vue.toasted.global.showErrorMessage({
                message: response.data.Messages[0] || "Thao tác thất bại!",
              });
            }
          }
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_TREE_DA_PXL_SEARCH_DATA", []);
        Vue.toasted.clear();
        Vue.toasted.global.showErrorMessage({
          message: error.response.data.Messages[0] || "Thao tác thất bại!",
        });
        reject(error);
      });
  });
};

const danhSachYKienPhanTrang = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDanhSachYKienPhanTrang(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

export default {
  getTreeDaPXLSearchData,
  xinYKien,
  duyetHSCV,
  huyDuyetHSCV,
  capNhatVaiTroTreePhanXuLy,
  getTreeDaPhanXuLy,
  getCountList,
  layLuongXuLy,
  layLichSuPhanXuLy,
  capNhatTHTH,
  layTreeDonVi,
  traLai,
  moLai,
  themYKienXuLy,
  suaYKienXuLy,
  xoaYKienXuLy,
  searchHoSoCongViec,
  taoHoSoCongViec,
  layChiTietHoSoCongViec,
  suaHoSoCongViec,
  xoaHoSoCongViec,
  exportHoSoCongViec,
  phanXuLy,
  layDoiTuongDuocTraLai,
  layTreePhanXuLy,
  layLichSuThuHoi,
  layLichSuTraLai,
  layLichSuCapNhatTinhHinhThucHien,
  thuHoi,
  ketThuc,
  setDangXuLy,
  setDaXuLy,
  suaHoSoCongViecVanBan,
  suaHoSoCongViecFile,
  danhSachYKienPhanTrang,
};
